<template>
	<v-card-text>{{plot}}</v-card-text>
</template>

<script>
export default {
	props: ['plot']
}
</script>